// File: frontend/src/components/MobileBottomNav.jsx

import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import {
  Home,
  Users,
  Trophy,
  Award,
  User,
  Swords,
} from "lucide-react";
import { AuthContext } from "../context/AuthContext";

export default function MobileBottomNav() {
  const { user } = useContext(AuthContext);

  // ---------------------------------------------------------
  // PROFILE IMAGE
  // ---------------------------------------------------------

  const profileImageSrc = useMemo(() => {
    if (!user) return null;

    // Admin avatar
    if (user.role === "admin") {
      return "https://warfc.com/api/uploads/admin.png";
    }

    // No profile image → generated avatar
    if (!user.image_url) {
      const name =
        `${user.name || ""} ${user.surname || ""}`.trim() ||
        "User";

      return `https://ui-avatars.com/api/?name=${encodeURIComponent(
        name
      )}&background=random&color=fff`;
    }

    // Absolute URL
    if (user.image_url.startsWith("http")) {
      return user.image_url;
    }

    // Relative API path
    return `https://warfc.com/api${user.image_url}`;
  }, [user]);

  return (
    <nav
      className="
        md:hidden
        fixed
        bottom-0
        left-0
        w-full
        bg-black
        border-t
        border-gray-800
        flex
        justify-around
        items-center
        py-2
        z-50
      "
    >

      {/* =====================================================
          HOME
      ===================================================== */}

      <Link
        to="/"
        className="
          flex
          flex-col
          items-center
          justify-center
          min-w-0
          flex-1
          text-gray-300
          hover:text-yellow-400
          transition-colors
          text-[10px]
          font-medium
          gap-1
        "
      >
        <Home size={21} strokeWidth={2} />
        <span>Home</span>
      </Link>

      {/* =====================================================
          RANKING
      ===================================================== */}

      <Link
        to="/ranking"
        className="
          flex
          flex-col
          items-center
          justify-center
          min-w-0
          flex-1
          text-gray-300
          hover:text-yellow-400
          transition-colors
          text-[10px]
          font-medium
          gap-1
        "
      >
        <Users size={21} strokeWidth={2} />
        <span>Ranking</span>
      </Link>

      {/* =====================================================
          EVENTS
      ===================================================== */}

      <Link
        to="/events"
        className="
          flex
          flex-col
          items-center
          justify-center
          min-w-0
          flex-1
          text-gray-300
          hover:text-cyan-400
          transition-colors
          text-[10px]
          font-medium
          gap-1
        "
      >
        <Swords size={21} strokeWidth={2} />
        <span>Events</span>
      </Link>

      {/* =====================================================
          TOURNAMENTS
      ===================================================== */}

      <Link
        to="/tournaments"
        className="
          flex
          flex-col
          items-center
          justify-center
          min-w-0
          flex-1
          text-gray-300
          hover:text-yellow-400
          transition-colors
          text-[10px]
          font-medium
          gap-1
        "
      >
        <Trophy size={21} strokeWidth={2} />
        <span>Tournament</span>
      </Link>

      {/* =====================================================
          CLUBS
      ===================================================== */}

      <Link
        to="/clubs"
        className="
          flex
          flex-col
          items-center
          justify-center
          min-w-0
          flex-1
          text-gray-300
          hover:text-yellow-400
          transition-colors
          text-[10px]
          font-medium
          gap-1
        "
      >
        <Award size={21} strokeWidth={2} />
        <span>Clubs</span>
      </Link>

      {/* =====================================================
          PROFILE / LOGIN
      ===================================================== */}

      {user ? (
        <Link
          to="/profile"
          className="
            flex
            flex-col
            items-center
            justify-center
            min-w-0
            flex-1
            text-gray-300
            hover:text-cyan-400
            transition-colors
            text-[10px]
            font-medium
            gap-1
          "
        >
          <img
            src={profileImageSrc}
            alt="Profile"
            className="
              w-[22px]
              h-[22px]
              rounded-full
              border-2
              border-cyan-400
              object-cover
            "
          />

          <span>Profile</span>
        </Link>
      ) : (
        <Link
          to="/login"
          className="
            flex
            flex-col
            items-center
            justify-center
            min-w-0
            flex-1
            text-gray-300
            hover:text-yellow-400
            transition-colors
            text-[10px]
            font-medium
            gap-1
          "
        >
          <User size={21} strokeWidth={2} />
          <span>Login</span>
        </Link>
      )}

    </nav>
  );
}